import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {supportService} from "../../services/support.service";

const initialState = {
    tickets: [],
    totalTickets: null,
    activeTicket: null,
    messages: [],
    status: '',
    messagesStatus: '',
    error: null,
};

const listTickets = createAsyncThunk(
    'supportSlice/listTickets',
    async (orderId) => {
        try {
            const {data} = await supportService.listTickets(orderId);
            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
);

const createTicket = createAsyncThunk(
    'supportSlice/createTicket',
    async (ticketData) => {
        try {
            const {data} = await supportService.createTicket(ticketData);
            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
);

const getTicket = createAsyncThunk(
    'supportSlice/getTicket',
    async ({id}) => {
        try {
            const {data} = await supportService.getTicket(id);
            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
);

const listMessages = createAsyncThunk(
    'supportSlice/listMessages',
    async ({ticketId}) => {
        try {
            const {data} = await supportService.listMessages(ticketId);
            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
);

const postMessage = createAsyncThunk(
    'supportSlice/postMessage',
    async ({ticketId, body, attachments}) => {
        try {
            const {data} = await supportService.postMessage(ticketId, {body, attachments});
            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
);

const markRead = createAsyncThunk(
    'supportSlice/markRead',
    async ({ticketId}) => {
        try {
            await supportService.markRead(ticketId);
            return ticketId;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
);

const supportSlice = createSlice({
    name: 'supportSlice',
    initialState,
    reducers: {
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        clearActiveTicket: (state) => {
            state.activeTicket = null;
            state.messages = [];
        },
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: builder => builder
        .addCase(listTickets.fulfilled, (state, action) => {
            if (Array.isArray(action.payload)) {
                state.tickets = action.payload;
                state.totalTickets = action.payload.length;
            } else {
                state.tickets = action.payload.results;
                state.totalTickets = action.payload.count;
            }
            state.status = 'success';
        })
        .addCase(listTickets.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(listTickets.rejected, (state) => {
            state.status = 'error';
        })

        .addCase(createTicket.fulfilled, (state, action) => {
            state.activeTicket = action.payload;
            state.status = 'success';
        })
        .addCase(createTicket.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(createTicket.rejected, (state, action) => {
            state.status = 'error';
            state.error = action.error?.message || 'Помилка створення звернення';
        })

        .addCase(getTicket.fulfilled, (state, action) => {
            state.activeTicket = action.payload;
            state.status = 'success';
        })
        .addCase(getTicket.pending, (state) => {
            state.status = 'loading';
        })

        .addCase(listMessages.fulfilled, (state, action) => {
            state.messages = Array.isArray(action.payload) ? action.payload : action.payload.results || [];
            state.messagesStatus = 'success';
        })
        .addCase(listMessages.pending, (state) => {
            state.messagesStatus = 'loading';
        })

        .addCase(postMessage.fulfilled, (state, action) => {
            state.messages = [...state.messages, action.payload];
            state.messagesStatus = 'success';
        })
        .addCase(postMessage.pending, (state) => {
            state.messagesStatus = 'sending';
        })
        .addCase(postMessage.rejected, (state) => {
            state.messagesStatus = 'error';
        })

        .addCase(markRead.fulfilled, (state, action) => {
            const ticketId = action.payload;
            const ticket = state.tickets.find((t) => t.id === ticketId);
            if (ticket) {
                ticket.unread_count = 0;
            }
            if (state.activeTicket && state.activeTicket.id === ticketId) {
                state.activeTicket = {...state.activeTicket, unread_count: 0};
            }
        })
});

const {actions, reducer: supportReducer} = supportSlice;

const supportActions = {
    ...actions,
    listTickets,
    createTicket,
    getTicket,
    listMessages,
    postMessage,
    markRead,
};

export {supportReducer, supportActions};
